export default __webpack_public_path__ + "static/media/test-twitter.860d86c7.svg";